import * as DashboardActionTypes from '../actions/dashboard';
import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.dashboardData, action) => {
    const { payload, type } = action;

    switch(type){

        case DashboardActionTypes.FETCH_DASHBOARD_DATA:
        case DashboardActionTypes.FETCH_DASHBOARD_DATA_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_DASHBOARD_DATA_REJECTED:
            return { ...state, ...errorResponseHandler(payload, 'DashboardData') }

        case DashboardActionTypes.FETCH_DASHBOARD_DATA_FULFILLED:
            return { ...state, data: payload.data }

        
        case DashboardActionTypes.FETCH_PREMIUM_TOTALS_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_PREMIUM_TOTALS_REJECTED:
            return { ...state, ...errorResponseHandler(payload, 'PremiumData') }
        
        case DashboardActionTypes.FETCH_PREMIUM_TOTALS_FULFILLED:
            return { ...state, premiumSuccess: true, premiumError: false, premium: payload.data }

        
        case DashboardActionTypes.FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_REJECTED:
            return { ...state, ...errorResponseHandler(payload, 'PolicyCountByPurchaseData') }

        case DashboardActionTypes.FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_FULFILLED:
            return { ...state, countError: false, countSuccess: true, purchaseTypeCount: payload.data }

        
        case DashboardActionTypes.FETCH_POLICY_COUNT_PENDING:
            return { ...state, policyCountError: false, policyCountSuccess: false }

        case DashboardActionTypes.FETCH_POLICY_COUNT_REJECTED:
            return { ...state, ...errorResponseHandler(payload, 'PolicyCountData') }

        case DashboardActionTypes.FETCH_POLICY_COUNT_FULFILLED:
            return { ...state, policyCountError: false, policyCountSuccess: true, policyCountSummary: payload.data.policy_count, commissionSummary: payload.data.commissions, claimsCountSummary: payload.data.claim_count, }

        
        case DashboardActionTypes.FETCH_PREMIUMS_BY_TYPE_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_PREMIUMS_BY_TYPE_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'PremiumsData') }

        case DashboardActionTypes.FETCH_PREMIUMS_BY_TYPE_FULFILLED:
            return { ...state, error: false, success: true, premiumByType: payload.data }

        
        case DashboardActionTypes.FETCH_MONTHLY_POLICY_COUNT_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_MONTHLY_POLICY_COUNT_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'MonthlyPolicyCountData') }

        case DashboardActionTypes.FETCH_MONTHLY_POLICY_COUNT_FULFILLED:
            return { ...state, success: true, monthlyCount: payload.data }

        
        case DashboardActionTypes.FETCH_PREMIUM_RATES_PENDING:
            return { ...state, premiumRatesLoading: true, premiumRates: [] }

        case DashboardActionTypes.FETCH_PREMIUM_RATES_REJECTED:
            return { ...state, premiumRatesLoading: false, ...errorResponseHandler(payload, 'PremiumRates') }

        case DashboardActionTypes.FETCH_PREMIUM_RATES_FULFILLED:
            return { ...state, premiumRatesLoading: false, premiumRates: payload.data }

        
        case DashboardActionTypes.FETCH_COUNT_PENDING:
            return { ...state, success: false, error: false, countLoading: true }

        case DashboardActionTypes.FETCH_COUNT_REJECTED:
            return { ...state, ...errorResponseHandler(payload, 'FetchCountData') }

        case DashboardActionTypes.FETCH_COUNT_FULFILLED:
            return { ...state, 
                success: true, 
                error: false, 
                countLoading: false, 
                claim_count: payload.data.claim_count, 
                commissions: payload.data.commissions, 
                policy_count: payload.data.policy_count
            }
        
        
        case DashboardActionTypes.FETCH_WEEKLY_SUMMARY_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_WEEKLY_SUMMARY_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'WeeklySummaryData') }

        case DashboardActionTypes.FETCH_WEEKLY_SUMMARY_FULFILLED:
            return { ...state, success: true, error: false, weeklySummary: payload.data }

        case DashboardActionTypes.FETCH_PREMIUM_SUMMARY:
        case DashboardActionTypes.FETCH_PREMIUM_SUMMARY_PENDING:
            return { ...state }

        case DashboardActionTypes.FETCH_PREMIUM_SUMMARY_REJECTED:
            return { ...state, error: true, ...errorResponseHandler(payload, 'FetchPremiumSummaryData') }

        case DashboardActionTypes.FETCH_PREMIUM_SUMMARY_FULFILLED:
            return { ...state, success: true, premium: payload.data }
        
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard.js